
import { post, get, put, remove } from '../../utils/http'

export function getAll() {
    return get('/member/');
}

export function MembersCSV(data) {
    return post('/member/csv', data);
}

export function sendAlertEmail(data) {
    return post('/member/sendAlertEmail', data);
}

export function lineChartTimeMembers() {
    return get('/member/lineChartTimeMembers');
}

export function newMember(data) {
    return post('/member/', data);
}

export function updateMember(member, data) {
    return put('/member/' + member, data);
}

export function deleteMember(member) {
    return remove('/member/' + member);
}

